export default "__VITE_ASSET__DTri8R5a__"